var _rect, _rect2, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    strokeWidth: 0.5,
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3752 3.98156C13.6432 3.67099 12.8398 3.5 12 3.5C8.89876 3.5 6.29342 5.83189 5.95094 8.9142L5.69914 11.1804L5.69288 11.2363C5.572 12.2897 5.2291 13.3056 4.68681 14.2168L4.65795 14.265L4.07991 15.2284L4.06599 15.2516C3.81556 15.669 3.60811 16.0147 3.47327 16.301C3.33718 16.5899 3.23229 16.9025 3.28456 17.2338C3.34107 17.5919 3.5254 17.9175 3.80345 18.1502C4.06063 18.3655 4.38261 18.4364 4.70041 18.4683C5.01528 18.5 5.41847 18.5 5.90519 18.5H5.93227H18.0678H18.0949C18.5816 18.5 18.9848 18.5 19.2997 18.4683C19.6175 18.4364 19.9395 18.3655 20.1966 18.1502C20.4747 17.9175 20.659 17.5919 20.7155 17.2338C20.7678 16.9025 20.6629 16.5899 20.5268 16.301C20.392 16.0147 20.1846 15.669 19.9342 15.2517L19.9341 15.2516L19.9202 15.2284L19.3421 14.265L19.3133 14.2168C18.771 13.3056 18.4281 12.2897 18.3072 11.2363L18.3009 11.1804L18.2585 10.798C17.9455 10.9016 17.6155 10.9677 17.2737 10.9908L17.3071 11.2909L17.3137 11.3503C17.4507 12.5442 17.8393 13.6955 18.4539 14.7282L18.4846 14.7795L19.0627 15.7429C19.3306 16.1894 19.5113 16.4918 19.6221 16.7271C19.7341 16.9649 19.7321 17.0504 19.7277 17.0779C19.7089 17.1973 19.6475 17.3058 19.5548 17.3834C19.5334 17.4013 19.4612 17.447 19.1996 17.4734C18.9408 17.4994 18.5885 17.5 18.0678 17.5H5.93227C5.41159 17.5 5.05923 17.4994 4.80051 17.4734C4.53889 17.447 4.4667 17.4013 4.4453 17.3834C4.35262 17.3058 4.29118 17.1973 4.27234 17.0779C4.26799 17.0504 4.26593 16.9649 4.37796 16.7271C4.48875 16.4918 4.66952 16.1894 4.9374 15.7429L5.51544 14.7795L5.54615 14.7282C6.16074 13.6955 6.54936 12.5442 6.68636 11.3503L6.69302 11.2909L6.94482 9.02463C7.23103 6.44875 9.40831 4.5 12 4.5C12.5837 4.5 13.1464 4.59884 13.6711 4.78142C13.8695 4.48435 14.1066 4.21532 14.3752 3.98156ZM16.1893 5.17115C15.8745 5.31089 15.6025 5.52951 15.3984 5.80192C16.2932 6.6054 16.9044 7.72482 17.0524 8.99933C17.407 8.99021 17.7386 8.8888 18.0242 8.71822C17.8234 7.32034 17.155 6.08721 16.1893 5.17115Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10222 18.4059C9.27315 19.1501 9.64978 19.8077 10.1737 20.2767C10.6976 20.7458 11.3396 21 12 21C12.6604 21 13.3024 20.7458 13.8263 20.2767C14.3502 19.8077 14.7269 19.1501 14.8978 18.4059",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 2,
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellPin);
export default __webpack_public_path__ + "static/media/bell_pin.e546c02e9fc3e6cd82f011540007a8da.svg";
export { ForwardRef as ReactComponent };